import { get } from '../tools/http';

const types = (state, key) => state.sections[key]
    ? state.sections[key].types
    : [];

const competences = (state, key) => types(state, key)
    .reduce((acc, cur) => [...acc, ...cur.clusters], [])
    .reduce((acc, cur) => [...acc, ...cur.competences], []);

const createCheckEntity = state => {
    return entity => {
        if (!entity) return;

        const index = state.findIndex(e => e.id == entity.id);

        if (index != -1) state.splice(index, 1, entity);
        else state.push(entity);
    };
};

const loadEntities = async (ctx, arr, path, mutation) => {
    const queries = arr
        .map(item => get('cms', `entity/select/${path}?id=${item && item.foreignActivityId ? item.foreignActivityId : item}`));

    const results = await Promise.all(queries);

    if (!results) return;

    ctx.commit(mutation, results.map(r => r.list[0]));
};

export default {
    namespaced: true,
    state: {
        sections: {},
        entities: {
            webinars: [],
            courses: [],
        },
    },
    mutations: {
        writeSection: (state, params) => {
            state.sections = {
                ...state.sections,
                [params.key]: {
                    types: params.types,
                    updated: Date.now(),
                },
            };
        },
        writeWebinars: (state, webinars) =>
            webinars.forEach(createCheckEntity(state.entities.webinars)),
        writeCourses: (state, courses) =>
            courses.forEach(createCheckEntity(state.entities.courses)),
    },
    actions: {
        loadByKey: async (ctx, key) => {
            const section = ctx.state.sections[key];

            if (section && section.updated > Date.now() - 60e3) return;

            const typeByKey = `api/v1/type/byKey/${key}?sort[0][column]=id&sort[0][order]=asc`;
            const types = await get('progress', typeByKey);

            if (!types) return;

            ctx.commit('writeSection', { key, types });
        },
        loadWebinars: async (ctx, arr) => {
            await loadEntities(ctx, arr, 'webinar', 'writeWebinars');
        },
        loadCourses: async (ctx, arr) => {
            await loadEntities(ctx, arr, 'course', 'writeCourses');
        },
    },
    getters: {
        typesByKey: state => key => types(state, key),

        competencesByKey: state => key => competences(state, key),

        competenceByKeyAndId: state => (key, id) => competences(state, key)
            .find(competence => competence.id == id),

        webinars: state => arr => state.entities.webinars
            .filter(w => arr.find(el => String(w.id) === String(el.foreignActivityId))),

        courses: state => arr => state.entities.courses
            .filter(c => arr.find(el => String(c.id) === String(el.foreignActivityId))),
    },
};
